import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  container: {
    display: 'flex',
    minWidth: '300px',
    padding: '10px 12px',
    height: '86px',
    border: "1px solid ".concat(palette.shades[300]),
    marginRight: '10px',
    backgroundColor: palette.shades[100],
    borderRadius: '4px',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: palette.shadows.hard,
      border: "2px solid ".concat(palette.shades[400]),
      backgroundColor: palette.shades[200]
    },
    '&.active': {
      border: "3px solid ".concat(palette.primary.main)
    }
  },
  iconBlock: {
    height: '24px',
    marginTop: '14px',
    marginRight: '6px'
  },
  descriptionBlock: {
    width: '100%',
    whiteSpace: 'break-spaces',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '& .MuiTypography-root': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  descriptionBlockAddress: {
    display: 'flex',
    alignItems: 'center'
  },
  statusBlock: {}
}));
export default useStyles;